import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export function PrivateRoute(isAdmin) {
  return isAdmin.isAdmin ? <Outlet /> : <Navigate to={'/'} />;
}
